var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect, useState } from "react";
import { connect } from '../../store/connect';
import { useHistory, useLocation } from "react-router";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { getInitialData, getSepaDirectDebitData, getSepaDirectDebitEntities, postSepaDirectDebitForm } from "../../store/actions/response.actions";
import { Loader } from "../Loader/Loader";
import pick from "lodash/pick";
import noop from "lodash/noop";
import merge from "lodash/merge";
import querystring from "querystring";
import parse from "html-react-parser";
import { getBookManager } from "../../models/BookModel";
import { TwoSidedForm } from "../Form/TwoSidedForm/TwoSidedForm";
import { ReactiveForm } from "../Form";
import { componentMapper, componentTypes, validatorMapper } from "../Form/form-constants";
import { useTranslation } from "react-i18next";
import { SEPA_DIRECT_DEBIT, SEPA_DIRECT_DEBIT_TITLE, SEPA_DIRECT_DEBIT_DESCRIPTION } from "../../classConstants";
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
import { useConfig } from "../../AppContext";
var directDebitPageFactory = function () {
    var DirectDebitPage = function (props) {
        var isOneSided = useConfig("oneSidedForm", props.isOneSided)[0];
        var search = useLocation().search;
        var t = useTranslation().t;
        var goBack = useHistory().goBack;
        var _a = useState(props.formData || {}), formValues = _a[0], setFormValues = _a[1];
        var payment_session_id = pick(querystring.parse(search.substr(1)), "payment_session_id").payment_session_id;
        var submitForm = function () {
            return props.postSepaDirectDebitForm(payment_session_id, props.formData);
        };
        var formSchema = {
            name: props.name,
            fields: __spreadArray(__spreadArray([], props.formFields), [{
                    component: componentTypes.FORM_BUTTONS,
                    onCancel: function () { return goBack(); },
                    onSubmit: noop,
                    backLabel: t("sepa_direct_debit.back"),
                    submitLabel: t("sepa_direct_debit.confirmButton"),
                    name: "form-buttons"
                }])
        };
        useEffect(function () {
            props.getSepaDirectDebitEntities(payment_session_id);
        }, []);
        useEffect(function () {
            setFormValues(props.formData);
        }, [JSON.stringify(props.formData)]);
        if (props.isLoading)
            return React.createElement(Loader, null);
        if (props.formFields.length === 0)
            return null;
        var renderTitle = function () {
            var title = t("sepa_direct_debit.title") || "";
            return title ? React.createElement("h2", { className: SEPA_DIRECT_DEBIT_TITLE }, title) : null;
        };
        var renderInfo = function () {
            var description = t("sepa_direct_debit.description", { company_title: props.company_title }) || "";
            return React.createElement("div", { className: SEPA_DIRECT_DEBIT_DESCRIPTION },
                " ",
                parse(description),
                " ");
        };
        var leftSideSection = function () {
            return isOneSided ? renderInfo() : null;
        };
        var rightSideSection = function () {
            return isOneSided ? null : renderInfo();
        };
        return (React.createElement(TwoSidedForm, { className: SEPA_DIRECT_DEBIT, leftSideOnly: isOneSided, rightSideSection: rightSideSection(), leftSideSection: leftSideSection() },
            renderTitle(),
            React.createElement(ReactiveForm, { name: formSchema.name, onSubmit: submitForm, componentMapper: componentMapper, validatorMapper: validatorMapper, initialValues: formValues, schema: formSchema })));
    };
    var mapStateToProps = function (state) {
        var validationErrors = (state.appReducer || {}).validationErrors;
        var initialData = (getInitialData(state.responseReducer) || {}).response;
        var response = getSepaDirectDebitData(state.responseReducer).response;
        var forms = (state.formReducer || {}).forms;
        var name = "sepamandate";
        return {
            response: response,
            initialData: initialData, validationErrors: validationErrors,
            name: name,
            form: forms[name],
            loaderState: state.loaderReducer
        };
    };
    var mergeProps = function (stateProps, dispatchProps, ownProps) {
        var _a;
        var form = stateProps.form, response = stateProps.response, initialData = stateProps.initialData, validationErrors = stateProps.validationErrors, loaderState = stateProps.loaderState, otherStateProps = __rest(stateProps, ["form", "response", "initialData", "validationErrors", "loaderState"]);
        var loadingState = new LoaderState(stateProps.loaderState, { keys: [API_METHODS_ENUM.GET_SEPA_ENTITIES] });
        var initialDataRM = initialData && getResponseManager(initialData);
        var options = initialDataRM === null || initialDataRM === void 0 ? void 0 : initialDataRM.options();
        var mergedProps = __assign(__assign(__assign(__assign({}, otherStateProps), dispatchProps), ownProps), { formFields: [], isOneSided: !!(options === null || options === void 0 ? void 0 : options.is_booking_form_one_sided), formData: form || { form_data: {}, }, company_title: options === null || options === void 0 ? void 0 : options.company_title, hasErrored: loadingState.hasErrored(), isLoading: !response || loadingState.isLoading() || !loadingState.hasLoaded() });
        if (initialDataRM && response) {
            var optionEntities = initialDataRM.entities();
            var rm = getResponseManager(response);
            var formData = merge({}, { form_data: rm.formData() } || {}, form);
            var entities = rm.entities();
            if (!entities)
                return mergedProps;
            var bm = getBookManager(__assign(__assign({}, entities), optionEntities));
            mergedProps.formData = formData;
            mergedProps.formFields =
                ((_a = bm.getSepaForm(formData, validationErrors)) === null || _a === void 0 ? void 0 : _a.reduce(function (allFields, _a) {
                    var fields = _a.fields;
                    return allFields.concat(fields);
                }, [])) || [];
        }
        return mergedProps;
    };
    return connect(mapStateToProps, { getSepaDirectDebitEntities: getSepaDirectDebitEntities, postSepaDirectDebitForm: postSepaDirectDebitForm }, mergeProps)(DirectDebitPage);
};
export var SepaDirectDebitPage = directDebitPageFactory();
